const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
